import { PublicQuestionOption } from "@/queries/types";
import orderBy from "lodash/orderBy";

export const sortOptions = (
  options: PublicQuestionOption[],
): PublicQuestionOption[] =>
  orderBy(options, [(option) => option.order_weight], ["asc"]);
